/**
 * Los conjuntos que se pueden dar de alta: los dos del Excel de Maxi, que son los únicos
 * con form. Por nombre y no por id, porque el id de Services cambia de base a base.
 */
export const CONJUNTOS_DEL_ALTA = ["Simple Products", "Services"];

/**
 * Cómo se llama cada conjunto **en la UI**. El nombre de Magento sigue siendo la clave
 * —filtros, búsqueda, el alta— y en la administración de Conjuntos se ve tal cual.
 */
const ETIQUETA_CONJUNTO: Record<string, string> = {
  "Simple Products": "Producto simple",
  Services: "Servicio",
};

export const etiquetaConjunto = (nombre: string) =>
  ETIQUETA_CONJUNTO[nombre] ?? nombre;

/** El título del form en un alta: dice qué se está creando, porque el conjunto no se ve. */
export const TITULO_DEL_ALTA: Record<string, string> = {
  "Simple Products": "Nuevo producto simple",
  Services: "Nuevo servicio",
};
